import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getFormatDetails } from "../../helpers/http_formats_requests";
import { useQuery } from "@tanstack/react-query";

export default function FormatDetails() {

    const navigate = useNavigate();

    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getFormatDetails', id], 
        queryFn: () => getFormatDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: formatData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Formato - Detalhes",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    return <DynamicFormPage 
        isLoading={isFetching} 
        details 
        initialData={formatData} 
        title={"Formato - Detalhes"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
    />;
};
